const memoryValues = new Map();

export function shouldUseSessionStorage({ hostname = "", integrationMode = "" } = {}) {
  const host = String(hostname).toLowerCase();
  return integrationMode === "remote"
    || host === "portal.completelawsupport.com"
    || host.endsWith(".vercel.app");
}

function activeStorage() {
  if (typeof window === "undefined") return null;
  const useSession = shouldUseSessionStorage({
    hostname: window.location?.hostname || "",
    integrationMode: import.meta.env?.VITE_APP_INTEGRATION_MODE || "",
  });
  try {
    return useSession ? window.sessionStorage : window.localStorage;
  } catch {
    return null;
  }
}

export const clientStorage = {
  getItem(key) {
    const storage = activeStorage();
    if (storage) return storage.getItem(key);
    return memoryValues.has(key) ? memoryValues.get(key) : null;
  },
  setItem(key, value) {
    const storage = activeStorage();
    if (storage) {
      storage.setItem(key, String(value));
      return;
    }
    memoryValues.set(key, String(value));
  },
  removeItem(key) {
    const storage = activeStorage();
    if (storage) storage.removeItem(key);
    memoryValues.delete(key);
  },
  clear() {
    const storage = activeStorage();
    if (storage) storage.clear();
    memoryValues.clear();
  },
  entries() {
    const storage = activeStorage();
    if (storage) {
      return Array.from({ length: storage.length }, (_, index) => storage.key(index))
        .filter(Boolean)
        .map((key) => [key, storage.getItem(key)]);
    }
    return Array.from(memoryValues.entries());
  },
};

export const SENSITIVE_CLIENT_STORAGE_PATTERN = /(client|matter|draft|form|audit|conflict|diary|billing|trust|demographic|application|guideline|authority|ata|vla|planner|bundle|travel|backsheet|memo|receipt|claim|uploaded|document)/i;

export function listLegacyPersistentClientKeys() {
  if (typeof window === "undefined" || !shouldUseSessionStorage({ hostname: window.location?.hostname || "" })) {
    return [];
  }
  try {
    return Array.from({ length: window.localStorage.length }, (_, index) => window.localStorage.key(index))
      .filter((key) => key && SENSITIVE_CLIENT_STORAGE_PATTERN.test(key));
  } catch {
    return [];
  }
}

export function clearLegacyPersistentClientData() {
  const keys = listLegacyPersistentClientKeys();
  for (const key of keys) window.localStorage.removeItem(key);
  return keys.length;
}
